// extracted by mini-css-extract-plugin
export var searchHeader = "_5z-0";
export var searchHeaderDark = "_5z-1";